import React from 'react'
import PropTypes from 'prop-types'
import { useFormatMetricValue } from 'components/common/hooks/useFormatMetricValue'
import { TruncatedText } from 'components/common/truncated-text'
import classNames from 'classnames/bind'
import { MetricTypes } from 'utils/constants'
import { getMetric, getTableCellStickyStyle } from '../../../../utils'
import styles from './MetricCell.module.scss'

const cx = classNames.bind(styles)

const MetricCell = ({
  metricData,
  metricType,
  previousColumn,
  value,
  analytics,
  stickyConfig,
  rowOdd,
}) => {
  const { formatMetricValue } = useFormatMetricValue()
  const metricValue = analytics ? value : metricData[getMetric(metricData.metricToGraph)]
  const formattedValue = formatMetricValue(metricType, metricValue, true, analytics)
  const isText = metricType === MetricTypes.TEXT

  return (
    <td
      className={cx('metric-cell')}
      style={getTableCellStickyStyle(stickyConfig, false, rowOdd) || {}}
    >
      {isText ? (
        <TruncatedText>{formattedValue}</TruncatedText>
      ) : (
        <p>{formattedValue}</p>
      )}

      {previousColumn && (
        <p>{formatMetricValue(metricType, metricData.previousValue, true, analytics)}</p> )}
    </td>
  )
}

MetricCell.propTypes = {
  metricData: PropTypes.shape().isRequired,
  previousColumn: PropTypes.bool.isRequired,
  metricType: PropTypes.string.isRequired,
  value: PropTypes.number,
  analytics: PropTypes.bool,
  stickyConfig: PropTypes.shape({
    width: PropTypes.number,
    left: PropTypes.number,
    zIndex: PropTypes.number
  }),
  rowOdd: PropTypes.bool,
}

MetricCell.defaultProps = {
  stickyConfig: null
}

export { MetricCell }
